import { render, staticRenderFns } from "./Goals.vue?vue&type=template&id=4f2f9b48"
import script from "./Goals.vue?vue&type=script&setup=true&lang=js"
export * from "./Goals.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Goals.vue?vue&type=style&index=0&id=4f2f9b48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports